<tabset class="nav nav-tabs dept-view-tab cs-secondary-tabs admin-secondry" #departmentTabs role="tablist">
      <tab autofocus (select)="selectTab(1)" id="department-view" [active]="activeTab==1"
            heading="{{'customer-service.View Department'|translate | translateKey}}" customClass="product-tabs"
            tabTitle="View Department">
            <div class="center-75per-width">
                  <department-view [departmentId]="departmentId"></department-view>
            </div>
      </tab>
      <tab *ngIf="editDepartmentPermission" autofocus (select)="selectTab(2)" id="manage-department"
            [active]="activeTab==2" heading="{{'customer-service.Manage Department'|translate | translateKey}}"
            customClass="product-tabs" tabTitle="Manage Department">

            <div class="">
                  <department *ngIf="activeTab==2" [departmentId]="departmentId"></department>
            </div>
      </tab>

      <tab *ngIf="viewUserPermission" autofocus (select)="selectTab(3)" id="department-user-search"
            [active]="activeTab==3" heading="{{'customer-service.Users'|translate | translateKey}}"
            customClass="product-tabs" tabTitle="Users">
            <div class="center-75per-width">
                  <department-user-search [departmentId]="departmentId" *ngIf="activeTab==3"
                        [operatingCountryId]="operatingCountryId"></department-user-search>
            </div>
      </tab>

      <tab autofocus class="dynamic-tab padding0" id="department-manage-user" *ngFor="let tab of userTabs; let i= index"
            [heading]="tab.title" [active]="tab.active" (select)="tab.active = true;" (deselect)="tab.active = false"
            [disabled]="tab.disabled" [removable]="tab.removable" (removed)="removeTab(tab)">
            <div class="center-75per-width" *ngIf="tab.managerUserTab">
                  <department-manage-user [userId]="tab.userId" [departmentId]="departmentId"
                        [operatingCountryId]="operatingCountryId" (removed)="removeTab(tab)"></department-manage-user>
            </div>

            <div autofocus class="center-75per-width" *ngIf="tab.assignUserTab">
                  <department-assign-user [departmentId]="departmentId" [operatingCountryId]="operatingCountryId">
                  </department-assign-user>
            </div>
      </tab>

      <tab *ngIf="emailConfigurationPermission && enableEmailConfiguration" autofocus (select)="selectTab(4)" id="email-configuration"
            [active]="activeTab==4" heading="{{'customer-service.Email Configuration'|translate | translateKey}}"
            customClass="product-tabs" tabTitle="Email Configuration">

            <div class="">
                  <email-configuration *ngIf="activeTab==4" [departmentId]="departmentId"></email-configuration>
            </div>
      </tab>
      <tab *ngIf="emailConfigurationPermission && enableEmailConfiguration" autofocus (select)="selectTab(5)" id="email-signature"
            [active]="activeTab==5" heading="{{'department-system.Email Signature'|translate | translateKey}}"
            customClass="product-tabs" tabTitle="Email Signature">
                  <app-email-signature [operatingCountryId]="operatingCountryId"></app-email-signature>
      </tab>
</tabset>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/admin/department-view-tabs.html